import { useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import HomeAboutPreviewMobile from './HomeAboutPreviewMobile';
import HomeAboutPreviewWeb from './HomeAboutPreviewWeb';

const HomeAboutPreview: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return isMobile ? <HomeAboutPreviewMobile /> : <HomeAboutPreviewWeb />;
};

export default HomeAboutPreview;
